// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";
import Requests from ".";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## Product Get
/**
 *
 * @param {{params: object, query: { search: string, companyId: string, customerId?: string, productCategoryId: string, lowToHighSort: boolean, mostSaleProductSort: boolean, newProductSort: boolean, prioritySort: boolean, onlyProduct: boolean, tagIds?: string, productTagFilterType?: string, page: number, limit: number  }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const version = localStorage.getItem("version");
  if (version === "v1") return await Requests.v1.Product.GetAll(option);
  const response = await $api.get(Endpoints.Product.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## Product Create
/**
 *
 * @param {{"name": string,"description": string,"productCategoryId": string,"price": number,"costPrice"?: number,"vatRate": number, stockCount: number, image: File, productInfos: Array, applyDiscount: boolean, isPriority: boolean, tagId?: string|null}} form
 *
 * @returns
 */
export const Create = async (form) => {
  const version = localStorage.getItem("version");

  if (version === "v1") return await Requests.v1.Product.Create(form);
  const response = await $api.post(Endpoints.Product.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Product Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Product.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Product Update
/**
 *
 * @param {{"name": string,"description": string,"productCategoryId": string,"price": number,"costPrice"?: number,"vatRate": number, stockCount: number, image: File, productInfos: Array, applyDiscount: boolean, isPriority: boolean, isActive: boolean, tagId?: string, clearTag?: boolean}} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const version = localStorage.getItem("version");
  if (version === "v1") return await Requests.v1.Product.Update(form, option);

  const response = await $api.put(Endpoints.Product.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Product Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Product.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
